<template>
  <a class="btn btn-outline-dark" role="button" @click="$router.go(-1)">
    <show-icon name="back" size="sm" class="align-middle"></show-icon>
    <span class="d-none d-sm-inline">{{ $t("back") }}</span>
  </a>  
</template>